define(function(require) {
	// models
	const confirmation_modal = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');
	const AttachmentModel = require('civicsModels/attachment_model');

	// templates
	const tpl = require('civicsViews/attachments/templates/t_itv_attachments_list.hbs');

	const ViewManager = require('civicsUtils/view_manager');
	const Radio = require('backbone.radio');
	const AttachmentDetailView = require('./v_itv_attachment_viewer')
	const imgThumbnailHeight = 100;

	return Marionette.ItemView.extend({
		initialize: function(options) {
			// if (__DEV__) console.log('itv_attachments_list -- initialize');
			this.config = options.config;
			this.globalConfig = ViewManager.globalConfig();
			var m = this.model.toJSON();
			//Model from AddInstrument - fileName : InstrumentDetail - filename
			var fileName = (m.filename) ? m.filename : m.fileName;
			this.attachId = m.id;
			this.title = (fileName) ? fileName : m.title;
			this.attachmentTitle = m.title;
			this.downloadPath = m.documentUri;
			this.thumbnailPath = m.thumbnailUri;
			this.isAddProcess = options.isAddProcess;
			this.isReviewProcess = options.isReviewProcess;
			this.allowDelete = options.allowDelete;
			this.modalRegion = options.modalRegion;
			this.parentMoniker = options.parentMoniker;
			this.parentPrimaryKey = options.parentPrimaryKey;
			this.documentTypeCollection = options.documentTypeCollection;
			this.isCustomer = options.isCustomer;
			this.isServiceProvider = options.isServiceProvider;
			this.isPublic = !options.isCustomer && !options.isServiceProvider;
			this.documentType = options.documentType;
			this.actions = options.actions;
			this.model.set('availableActions', this.actions);
			this.randId = Math.floor(Math.random()*100000);

			this.usesNewAttachments = ViewManager.versionRange('8.8.0.0');

			//what in the world
			// this.canUpdate = (this.usesNewAttachments && ((this.actions.update.customer && this.isCustomer) || (this.actions.update.serviceProvider && this.isServiceProvider) || (this.actions.update.public && this.isPublic))) || (this.usesNewAttachments && this.isAddProcess);
			// this.canOpen = ((this.usesNewAttachments && ((this.actions.open.customer && this.isCustomer) || (this.actions.open.serviceProvider && this.isServiceProvider) || (this.actions.open.public && this.isPublic))) && !this.isAddProcess) || (!this.usesNewAttachments && !this.isAddProcess );

			const hasUpdatePermission = this.usesNewAttachments && (
				(this.actions.update.customer && this.isCustomer) ||
				(this.actions.update.serviceProvider && this.isServiceProvider) ||
				(this.actions.update.public && this.isPublic)
			);
			this.canUpdate = hasUpdatePermission || (this.usesNewAttachments && this.isAddProcess);

			const hasOpenPermission = this.usesNewAttachments && (
				(this.actions.open.customer && this.isCustomer) ||
				(this.actions.open.serviceProvider && this.isServiceProvider) ||
				(this.actions.open.public && this.isPublic)
			);
			this.canOpen = (hasOpenPermission && !this.isAddProcess) || (!this.usesNewAttachments && !this.isAddProcess);

			this.newAttachmentsCollection = options.newAttachmentsCollection;
		},
		ui: {
			$image: '.attachment-thumbnail',
			description: '.description-section',
			$iconPreview: '.file-icon-preview',
			$imagePreview: '.image-thumbnail',
		},
		template: tpl,
		tagName: 'li',
		className: function() {
			return 'attachment-item';
		},
		modelEvents: {
			change: 'render',
		},
		events: {
			'click .download-link': 'downloadAttachment',
			'load .attachment-thumbnail': 'setImageSize',
			'click .delete-link': 'deleteAttachmentClicked',
			'click .details-link': 'detailsClicked'
		},
		onShow: function() {
			this.ui.$imagePreview.hide();
			this.ui.$iconPreview.hide();

			if (this.isAddProcess) {
				this.previewAttachmentIconThumbnail();
			}
		},
		previewAttachmentIconThumbnail: function() {
			var self = this;

			var mimeType = self.model.get('File').get('Type');
			if (mimeType != undefined && typeof self.ui.$imagePreview === 'object' || typeof this.ui.$iconPreview === 'object') {
				if (mimeType != null && mimeType.split('/')[0] === 'image') {
					var attachmentReader = new FileReader();
					attachmentReader.onload = function(e) {
						if (typeof self.ui.$imagePreview === 'object') {
							var image = new Image();
							image.src = e.target.result;
							self.imgUrl = e.target.result;
							image.onload = function() {
								if (typeof this.height !== 'undefined' && this.height < imgThumbnailHeight && this.height > 0) {
									self.ui.$imagePreview.height(this.height);
								} else {
									if (this.height > this.width) {
										self.ui.$imagePreview.height(imgThumbnailHeight);
									} else {
										self.ui.$imagePreview.width(imgThumbnailHeight);
									}
								}
								self.ui.$imagePreview.attr('src', image.src);
							}
						}
					}
					var fileName = self.model.get('fileName');
					if (fileName && fileName.length > 0) {
						if (self.newAttachmentsCollection.models) {
							var newAttachment = self.newAttachmentsCollection.where({
								fileName: fileName
							});
							if (newAttachment.length == 1) {
								var file = newAttachment[0].get("file");
							}
						} else {
							var newAttachment = _.findWhere(self.newAttachmentsCollection, {
								fileName: fileName
							});
							if (newAttachment) {
								var file = newAttachment.file;
							}
						}
						if (file && file instanceof Blob) {
							attachmentReader.readAsDataURL(file);
							self.file = file;
							self.ui.$imagePreview.show();
						}
					}
				} else {
					self.ui.$iconPreview.show();
				}
			}
		},
		onRender: function() {
			this.$el.rhythmThemeInit();

			this.ui.$image.on('load', function() {
				var height = this.ui.$image.prop('naturalHeight');
				var width = this.ui.$image.prop('naturalWidth');
				if (height != null && height > 0 && width != null && width > 0) {
					this.ui.$image.height(height);
					this.ui.$image.width(width);
				}
			}.bind(this));

			if (this.model.get('description') === " ") {
				this.ui.description.addClass("no-description");
			}

			if (this.isAddProcess && !(typeof this.imgUrl == 'undefined')) {
				this.ui.$imagePreview.attr('src', this.imgUrl);
				if (this.ui.$imagePreview.height() > this.ui.$imagePreview.width()) {
					this.ui.$imagePreview.height(imgThumbnailHeight);
				} else {
					this.ui.$imagePreview.width(imgThumbnailHeight);
				}

				this.ui.$iconPreview.hide();

			}
		},
		setImageSize: function() {
			var height = $image.naturalHeight;
			var width = $image.naturalWidth;
		},
		downloadAttachment: function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();
			this.triggerMethod('singleDownload:clicked', this.downloadPath);
		},
		detailsClicked: function(e) {
			e.preventDefault();
			var self = this;


			$.when(this.documentTypesLoaded).done(function() {


				self.modalView = new AttachmentDetailView({
					config: self.config,
					model: self.model,
					documentTypeCollection: self.documentTypeCollection,
					parentMoniker: self.parentMoniker,
					parentPrimaryKey: self.parentPrimaryKey,
					isAddProcess: self.isAddProcess,
					documentType: self.documentType,
					isCustomer: self.isCustomer,
					isPublic: self.isPublic,
					isServiceProvider: self.isServiceProvider,
					canUpdate: self.canUpdate,
					file: self.isAddProcess && self.file && self.file instanceof Blob ? self.file : null,
					newAttachmentsCollection: self.isAddProcess ? self.newAttachmentsCollection : null,
				});

				self.modalRegion.show(self.modalView);
				self.modalRegion.showModal();
			});

		},
		deleteAttachmentClicked: function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();
			if (!this.isAddProcess) {
				this.modalView = new confirmation_modal({
					title: i18n.t('CIVICS.COMMON.CONFIRMATION'),
					instructions: i18n.t('CIVICS.COMMON.DELETE_ATTACHMENT'),
					applicationTitle: this.model.get('title') + ' (' + this.model.get('filename') + ')',
					cancelButtonText: i18n.t('CIVICS.COMMON.BACK'),
					submitButtonText: i18n.t('CIVICS.COMMON.DELETE'),
					confirmationCallback: this.deleteConfirmation.bind(this),
					modalRegion: this.modalRegion,
				});
			} else {
				this.modalView = new confirmation_modal({
					title: i18n.t('CIVICS.COMMON.CONFIRMATION'),
					instructions: i18n.t('CIVICS.ATTACHMENTS.REMOVE_ATTACHMENT'),
					cancelButtonText: i18n.t('CIVICS.COMMON.NO'),
					submitButtonText: i18n.t('CIVICS.COMMON.YES'),
					confirmationCallback: this.deleteConfirmation.bind(this),
					modalRegion: this.modalRegion,
				});
			}
			this.modalRegion.show(this.modalView);
			this.modalRegion.showModal();
		},
		deleteConfirmation: function() {
			if (!this.isAddProcess) {
				var attachmentModel = new AttachmentModel(this.model.toJSON());
				attachmentModel.isDelete = true;
				attachmentModel.set('parentMoniker', this.parentMoniker);
				attachmentModel.set('parentPrimaryKey', this.parentPrimaryKey);
				if( this.config.IsForBilling == true)
					attachmentModel.set('accountId', this.config.BillingAccountKey);

				var self = this;

				ViewManager.loading(true);

				attachmentModel.destroy({
					data: {
						"provider": attachmentModel.get('provider')
					},
					success: function(model, response) {
						ViewManager.loading(false);
						self.modalRegion.hideModal();
						self.triggerMethod('attachments:delete', self.model);

					},
					error: function(model, response) {
						ViewManager.loading(false);
						self.modalRegion.hideModal();

						ViewManager.errorToWindow(response, self);

					}
				});
			} else {
				this.modalRegion.hideModal();
				this.triggerMethod('attachments:delete', this.model);
			}

		},
		showThumbnail: function() {
			var show = true;
			if (ViewManager.versionRange('8.6.0.0')) {
				if (this.isAddProcess) {
					show = false;
				}
			}
			return show;
		},
		determineDocumentType: function(model) {
			if (!ViewManager.versionRange('8.8.0.0')) {
				return null;
			}

			return this.documentTypeCollection.find(function(doctype) {
				return doctype.get('name') == model.get('name');
			});
		},
		getHtmlId: function() {
      if(this.model.get('id')== null || this.model.get('id').length ==0) {
        return  this.randId;
      }
      return this.model.get('id');
    },
		templateHelpers: function() {
			var self = this;

			var usesNewAttachments = ViewManager.versionRange('8.8.0.0');

			var documentType = "";
			if (usesNewAttachments) {
				var description = self.documentType != null ? (self.documentType.get('description') && self.documentType.get('description').length > 0) ? self.documentType.get('description') : self.documentType.get('name') : "";
				documentType = self.documentType != null ? (self.documentType.get('portalDescription').length > 0) ? self.documentType.get('portalDescription') : description : "";
			}

			let virusScanStatus = this.model.get('virusScanResults')?.toJSON() || {safe:true};

			return {
				hasMissingRequirements: self.model.get('missingRequirements') && self.model.get('missingRequirements').length > 0,
				canDelete:  (usesNewAttachments && ((self.actions.delete.customer && self.isCustomer) || (self.actions.delete.serviceProvider && self.isServiceProvider) || (self.actions.delete.public && self.isPublic))) || self.isAddProcess,
				hasDownloadLink: virusScanStatus.safe && ((usesNewAttachments && self.canOpen) || (!usesNewAttachments && !self.isPublic)), // for 11.1, the download button should not be shown
				showDefaultImage: !self.showThumbnail(),
				showThumbnail: self.showThumbnail(),
				canOpen: self.canOpen,
				canUpdate: self.canUpdate,
				isReviewProcess: this.isReviewProcess,
				thumbnailPath: this.thumbnailPath,
				attachmentTitle: usesNewAttachments ? self.attachmentTitle : "",
				title: self.title,
				documentType: (usesNewAttachments) ? documentType : "",
				description: self.model.get('description'),
				addedDate: self.model.get('addedDateTime') ? self.model.get('addedDateTime') : '',
				
				hasModalLink: virusScanStatus.safe &&((usesNewAttachments && self.canOpen) || (usesNewAttachments && self.canUpdate && self.isAddProcess)),
				isAddProcess: self.isAddProcess,
				fileType: (self.isAddProcess && typeof self.model.get('fileName') !== 'undefined') ? self.model.get('fileName').substring(self.model.get('fileName').lastIndexOf('.')) : '',
				breakUnderscores: function(text) {
				if (!text) return '';
				// First escape HTML to prevent XSS, then add zero-width spaces for word breaks
				var escaped = Handlebars.helpers['global:sanitize'](text, { hash: { allowedTags: 'br' } });
				return escaped.replace(/_/g, "&#8203;_");
				},
				deleteLabel: i18n.t('CIVICS.COMMON.DELETE_THIS', { type: i18n.t('CIVICS.ATTACHMENTS.ATTACHMENT'), id: self.title }),
				missingRequirementsLabel: i18n.t('CIVICS.ATTACHMENTS.ATTACHMENT_MISSING_REQUIREMENTS', { id: self.title }),
				attachmentImageId: this.getHtmlId(),
				htmlId: this.getHtmlId(),
				pendingStatus: virusScanStatus.pending === true,
				infectedStatus: virusScanStatus.infected === true
			};
		},
	});
});
